import { formatDate } from "@/helpers/formatDate";

type ArticleDateProps = {
  date: string;
  format?: string;
};

export const ArticleDate = ({ date, format = "MMM D, YYYY" }: ArticleDateProps) => (
  <>{date ? formatDate(date) : ""}</>
);
